// @flow

import bancoDoBrasilSrc from './bancodobrasil.svg';
import banrisulSrc from './banrisul.svg';
import bradescoSrc from './bradesco.svg';
import caixaSrc from './caixa.svg';
import itauSrc from './itau.svg';
import santanderSrc from './santander.svg';

export function getImageSourceFromCode(code: string): string {
  switch (code) {
    case 'bancodobrasil':
      return bancoDoBrasilSrc;

    case 'banrisul':
      return banrisulSrc;

    case 'bradesco':
      return bradescoSrc;

    case 'caixa':
      return caixaSrc;

    case 'itau':
      return itauSrc;

    case 'santander':
      return santanderSrc;

    default:
      throw new Error(`TEF Bank Icon: there is no icon for "${code}"`);
  }
}
